export enum SortingDirection {
  ASC = 'Asc',
  DESC = 'Desc',
}
